/**
 * Environment Configuration
 * Centralized configuration for environment variables and constants
 */

export const env = {
  // API Configuration
  AUTH_BASE_URL: process.env.NEXT_PUBLIC_AUTH_BASE_URL,
  LOG_ANALYZER_API_BASE_URL: process.env.NEXT_PUBLIC_LOG_ANALYZER_API_BASE_URL,
  LOG_ANALYZER_API_BASE_URL_PROD: process.env.NEXT_PUBLIC_LOG_ANALYZER_API_BASE_URL_PROD,
  FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
  API_TIMEOUT: 30000, // 30 seconds
  
  // Storage Keys
  JWT_STORAGE_KEY: 'auth_jwt_token',
  USER_STORAGE_KEY: 'auth_user_data',
  ORGANIZATION_STORAGE_KEY: 'auth_organization_data',
  // Session Storage Keys
  SESSION_STATE_KEY: 'auth_session_state',
  REDIRECT_AFTER_LOGIN_KEY: 'auth_redirect_after_login',
  LOG_ANALYZER_ENV_KEY: 'log_analyzer_environment',
  // Cross-tab logout event key
  LOGOUT_EVENT_KEY: 'auth_logout_event',
  // UI State Cache Keys (SessionStorage - cleared on tab close)
  MONITOR_LIST_UI_STATE_KEY: 'obx_monitor_list_ui_state',
  MONITOR_DETAIL_UI_STATE_KEY: 'obx_monitor_detail_ui_state',
  
  // UI State Cache Keys (LocalStorage - persists across sessions)
  MONITOR_DETAIL_RESPONSE_TIME_PERIOD_KEY: 'obx_monitor_detail_response_time_period',
  MONITOR_DETAIL_PERFORMANCE_ANALYSIS_PERIOD_KEY: 'obx_monitor_detail_performance_analysis_period',
  MONITOR_DETAIL_HTTP_ERRORS_FILTERS_KEY: 'obx_monitor_detail_http_errors_filters',
  MONITOR_DETAIL_ACTIVITY_LOGS_FILTERS_KEY: 'obx_monitor_detail_activity_logs_filters',
  PATTERN_ANALYSIS_PERIOD_KEY: 'obx_pattern_analysis_period',
  PATTERN_ANALYSIS_THRESHOLD_VIOLATIONS_FILTERS_KEY: 'obx_pattern_analysis_threshold_violations_filters',
  PATTERN_ANALYSIS_HTTP_ERRORS_FILTERS_KEY: 'obx_pattern_analysis_http_errors_filters',
  
  // Cookie Keys (reserved for future use)
  AUTH_TOKEN_COOKIE: 'auth_auth_token',
  REFRESH_TOKEN_COOKIE: 'auth_refresh_token',
  USER_COOKIE: 'auth_user',
  
  // Environment
  NODE_ENV: process.env.APP_ENV || 'development',
  IS_PRODUCTION: process.env.APP_ENV === 'production',
  IS_DEVELOPMENT: process.env.APP_ENV === 'development',
};

/**
 * Get API base URL
 */
export const getApiBaseUrl = (): string => {
  return env.AUTH_BASE_URL!;
};

/**
 * Check if running in browser
 */
export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};


